"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainSuggestStore = void 0;
const background_1 = require("@keplr-wallet/background");
const mobx_1 = require("mobx");
const cosmos_1 = require("@keplr-wallet/cosmos");
const axios_1 = __importDefault(require("axios"));
const common_1 = require("@keplr-wallet/common");
class ChainSuggestStore {
    constructor(interactionStore, communityChainInfoRepo) {
        this.interactionStore = interactionStore;
        this.communityChainInfoRepo = communityChainInfoRepo;
        this._isLoading = false;
        this.communityChainInfo = new Map();
        mobx_1.makeObservable(this);
    }
    get waitingSuggestedChainInfo() {
        const datas = this.interactionStore.getDatas(background_1.SuggestChainInfoMsg.type());
        if (datas.length > 0) {
            return datas[0];
        }
    }
    get communityChainInfoRepoUrl() {
        return `https://github.com/${this.communityChainInfoRepo.organizationName}/${this.communityChainInfoRepo.repoName}`;
    }
    getCommunityChainInfoUrl(chainId) {
        const chainIdHelper = cosmos_1.ChainIdHelper.parse(chainId);
        return `${this.communityChainInfoRepoUrl}/blob/${this.communityChainInfoRepo.branchName}/cosmos/${chainIdHelper.identifier}.json`;
    }
    getCommunityChainInfo(chainId) {
        const chainIdentifier = cosmos_1.ChainIdHelper.parse(chainId).identifier;
        if (!this.communityChainInfo.has(chainIdentifier)) {
            this.fetchCommunityChainInfo(chainId);
        }
        return this.communityChainInfo.get(chainIdentifier);
    }
    *fetchCommunityChainInfo(chainId) {
        const chainIdentifier = cosmos_1.ChainIdHelper.parse(chainId).identifier;
        const communityChainInfo = this.communityChainInfo.get(chainIdentifier);
        if (communityChainInfo) {
            return;
        }
        this.communityChainInfo.set(chainIdentifier, {
            isLoading: true,
            chainInfo: undefined,
        });
        try {
            const response = yield* common_1.toGenerator(axios_1.default.get(`/cosmos/${chainIdentifier}.json`, {
                baseURL: `https://raw.githubusercontent.com/${this.communityChainInfoRepo.organizationName}/${this.communityChainInfoRepo.repoName}/${this.communityChainInfoRepo.branchName}`,
            }));
            if (cosmos_1.ChainIdHelper.parse(response.data.chainId).identifier !==
                chainIdentifier) {
                throw new Error(`Invalid chain identifier: (expected: ${chainIdentifier}, actual: ${cosmos_1.ChainIdHelper.parse(response.data.chainId).identifier})`);
            }
            this.communityChainInfo.set(chainIdentifier, {
                isLoading: false,
                chainInfo: response.data,
            });
        }
        catch (e) {
            console.log(e);
            this.communityChainInfo.set(chainIdentifier, {
                isLoading: false,
                chainInfo: undefined,
            });
        }
    }
    *approve(chainInfo) {
        this._isLoading = true;
        try {
            const data = this.waitingSuggestedChainInfo;
            if (data) {
                yield this.interactionStore.approve(data.type, data.id, chainInfo);
            }
        }
        finally {
            this._isLoading = false;
        }
    }
    *reject() {
        this._isLoading = true;
        try {
            const data = this.waitingSuggestedChainInfo;
            if (data) {
                yield this.interactionStore.reject(data.type, data.id);
            }
        }
        finally {
            this._isLoading = false;
        }
    }
    *rejectAll() {
        this._isLoading = true;
        try {
            yield this.interactionStore.rejectAll(background_1.SuggestChainInfoMsg.type());
        }
        finally {
            this._isLoading = false;
        }
    }
    get isLoading() {
        return this._isLoading;
    }
}
__decorate([
    mobx_1.observable
], ChainSuggestStore.prototype, "_isLoading", void 0);
__decorate([
    mobx_1.observable.shallow
], ChainSuggestStore.prototype, "communityChainInfo", void 0);
__decorate([
    mobx_1.flow
], ChainSuggestStore.prototype, "fetchCommunityChainInfo", null);
__decorate([
    mobx_1.flow
], ChainSuggestStore.prototype, "approve", null);
__decorate([
    mobx_1.flow
], ChainSuggestStore.prototype, "reject", null);
__decorate([
    mobx_1.flow
], ChainSuggestStore.prototype, "rejectAll", null);
exports.ChainSuggestStore = ChainSuggestStore;
//# sourceMappingURL=chain-suggest.js.map